const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

const setupJerseyHeaderNavigation = () => {
  const jerseyPath = '/collections/';
  const directLinks = [
    ['All Jerseys', 'jerseys'],
    ['New 26/27', 'new-26-27'],
    ['Best Sellers', 'jersey-best-sellers'],
    ['Special Edition', 'special-edition'],
    ['Retro', 'retro'],
    ['Offers', 'jersey-offers'],
  ];
  const leagueLinks = [
    ['Premier League', 'premier-league'],
    ['La Liga', 'la-liga'],
    ['Serie A', 'serie-a'],
    ['Bundesliga', 'bundesliga'],
    ['Ligue 1', 'ligue-1'],
    ['National Teams', 'national-teams'],
  ];

  document.querySelectorAll('.sf-nav__item').forEach((item) => {
    const link = item.querySelector(':scope > .sf-nav__trigger-row .sf-nav__link, :scope > .sf-nav__link');
    if (link?.textContent.trim().toUpperCase() !== 'JERSEYS') return;
    const dropdown = item.querySelector(':scope > .sf-dropdown');
    if (!dropdown) return;
    dropdown.innerHTML = `
      ${directLinks.map(([label, handle]) => `<a href="${jerseyPath}${handle}">${label}</a>`).join('')}
      <div class="sf-dropdown__branch">
        <div class="sf-dropdown__row">
          <a class="sf-dropdown__link" href="${jerseyPath}jerseys">Shop by League</a>
          <button class="sf-dropdown__toggle" type="button" data-sf-desktop-toggle aria-expanded="false" aria-controls="sf-desktop-jersey-leagues">
            <span class="visually-hidden">Show league options</span>
            <svg class="sf-nav__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
          </button>
        </div>
        <div class="sf-dropdown__submenu" id="sf-desktop-jersey-leagues" hidden>
          ${leagueLinks.map(([label, handle]) => `<a class="sf-dropdown__model" href="${jerseyPath}${handle}">${label}</a>`).join('')}
        </div>
      </div>
    `;
  });

  document.querySelectorAll('.sf-mobile-nav__group').forEach((group) => {
    const link = group.querySelector(':scope > .sf-mobile-nav__row .sf-mobile-nav__link');
    if (link?.textContent.trim().toUpperCase() !== 'JERSEYS') return;
    const children = group.querySelector(':scope > .sf-mobile-nav__children');
    if (!children) return;
    children.innerHTML = `
      ${directLinks.map(([label, handle]) => `<a class="sf-mobile-nav__grandchild" href="${jerseyPath}${handle}" data-sf-mobile-close>${label}</a>`).join('')}
      <div class="sf-mobile-nav__subgroup">
        <div class="sf-mobile-nav__row">
          <a class="sf-mobile-nav__link" href="${jerseyPath}jerseys" data-sf-mobile-close>Shop by League</a>
          <button class="sf-mobile-nav__toggle" type="button" data-sf-mobile-toggle aria-expanded="false" aria-controls="sf-mobile-jersey-leagues">
            <span class="visually-hidden">Show league options</span>
            <svg class="sf-mobile-nav__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
          </button>
        </div>
        <div class="sf-mobile-nav__children" id="sf-mobile-jersey-leagues" hidden>
          ${leagueLinks.map(([label, handle]) => `<a class="sf-mobile-nav__grandchild" href="${jerseyPath}${handle}" data-sf-mobile-close>${label}</a>`).join('')}
        </div>
      </div>
    `;
  });
};

ready(() => {
  setupJerseyHeaderNavigation();
  const header = document.querySelector('[data-superfoot-header]');
  const whatsapp = header?.dataset.whatsappUrl;
  if (whatsapp) {
    document.querySelectorAll('.sf-whatsapp-link').forEach((link) => {
      link.href = whatsapp;
      link.hidden = false;
    });
    document.querySelectorAll('.sf-whatsapp-link-fallback').forEach((label) => {
      label.hidden = true;
    });
  }

  document.addEventListener('click', (event) => {
    const cartTrigger = event.target.closest('[data-sf-cart-open]');
    if (cartTrigger) {
      event.preventDefault();
      const drawer = document.querySelector('#cart-drawer');
      if (drawer?.open) drawer.open();
      else drawer?.querySelector('dialog')?.showModal();
    }
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sf-mobile-toggle]');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sf-desktop-toggle]');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    if (!expanded && toggle.dataset.sfDesktopLevel === 'top') {
      document.querySelectorAll('[data-sf-desktop-level="top"][aria-expanded="true"]').forEach((otherToggle) => {
        if (otherToggle === toggle) return;
        const otherPanel = document.getElementById(otherToggle.getAttribute('aria-controls'));
        otherToggle.setAttribute('aria-expanded', 'false');
        if (otherPanel) otherPanel.hidden = true;
        otherToggle.closest('.sf-nav__item')?.classList.remove('is-open');
      });
    }

    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
    if (toggle.dataset.sfDesktopLevel === 'top') {
      toggle.closest('.sf-nav__item')?.classList.toggle('is-open', !expanded);
    }
  });

  const desktopViewport = window.matchMedia('(min-width: 990px)');
  const setDesktopPanel = (toggle, expanded) => {
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    if (toggle.dataset.sfDesktopLevel === 'top') {
      toggle.closest('.sf-nav__item')?.classList.toggle('is-open', expanded);
    }
  };

  document.querySelectorAll('.sf-nav__item').forEach((item) => {
    const toggle = item.querySelector(':scope > .sf-nav__trigger-row [data-sf-desktop-level="top"]');
    if (!toggle) return;

    item.addEventListener('mouseenter', () => {
      if (!desktopViewport.matches) return;
      document.querySelectorAll('[data-sf-desktop-level="top"]').forEach((otherToggle) => {
        if (otherToggle !== toggle) setDesktopPanel(otherToggle, false);
      });
      setDesktopPanel(toggle, true);
    });

    item.addEventListener('mouseleave', () => {
      if (!desktopViewport.matches) return;
      item.querySelectorAll('[data-sf-desktop-toggle]').forEach((itemToggle) => setDesktopPanel(itemToggle, false));
    });
  });

  document.querySelectorAll('.sf-dropdown__branch').forEach((branch) => {
    const toggle = branch.querySelector(':scope > .sf-dropdown__row [data-sf-desktop-toggle]');
    if (!toggle) return;
    branch.addEventListener('mouseenter', () => {
      if (desktopViewport.matches) setDesktopPanel(toggle, true);
    });
    branch.addEventListener('mouseleave', () => {
      if (desktopViewport.matches) setDesktopPanel(toggle, false);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.sf-nav')) return;
    document.querySelectorAll('[data-sf-desktop-toggle][aria-expanded="true"]').forEach((toggle) => {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      toggle.closest('.sf-nav__item')?.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sf-desktop-toggle][aria-expanded="true"]').forEach((toggle) => {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      toggle.closest('.sf-nav__item')?.classList.remove('is-open');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-sf-mobile-close]')) return;
    document.querySelectorAll('.sf-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  });
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-sf-gallery-image]');
  if (!trigger) return;
  const gallery = trigger.closest('[data-sf-pdp-gallery]');
  const main = gallery?.querySelector('[data-sf-gallery-main]');
  if (!main) return;
  main.src = trigger.dataset.sfGalleryImage;
  main.srcset = '';
  main.alt = trigger.dataset.sfGalleryAlt || '';
  gallery.querySelectorAll('.sf-pdp-gallery__thumb').forEach((thumb) => {
    thumb.classList.toggle('is-active', thumb.dataset.sfGalleryImage === trigger.dataset.sfGalleryImage);
  });
});

document.addEventListener('click', (event) => {
  const searchTrigger = event.target.closest('[data-sf-search-open]');
  if (!searchTrigger) return;

  const searchComponent = document.querySelector('#search-modal');
  const searchDialog = searchComponent?.querySelector('dialog');
  if (!searchDialog) return;

  event.preventDefault();
  if (typeof searchComponent.open === 'function') {
    searchComponent.open();
  } else if (!searchDialog.open && typeof searchDialog.showModal === 'function') {
    searchDialog.showModal();
  }
  window.setTimeout(() => searchDialog.querySelector('input[type="search"]')?.focus(), 80);
});


const setupMobileClubCarousels = (root = document) => {
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  root.querySelectorAll('[data-sf-clubs-carousel]').forEach((viewport) => {
    if (viewport.dataset.sfClubsReady === 'true') return;

    const track = viewport.querySelector('[data-sf-clubs-track]');
    const firstGroup = track?.querySelector('.sf-clubs-group');
    if (!track || !firstGroup) return;

    viewport.dataset.sfClubsReady = 'true';

    let isInteracting = false;
    let resumeAt = 0;
    let lastFrame = performance.now();

    const getLoopWidth = () => {
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstGroup.getBoundingClientRect().width + gap;
    };

    const normalizePosition = () => {
      const loopWidth = getLoopWidth();
      if (loopWidth > 0 && viewport.scrollLeft >= loopWidth) {
        viewport.scrollLeft -= loopWidth;
      }
    };

    const pauseTemporarily = (delay = 2600) => {
      resumeAt = performance.now() + delay;
    };

    viewport.addEventListener('pointerdown', () => {
      isInteracting = true;
    }, { passive: true });

    window.addEventListener('pointerup', () => {
      if (!isInteracting) return;
      isInteracting = false;
      pauseTemporarily();
    }, { passive: true });

    window.addEventListener('pointercancel', () => {
      if (!isInteracting) return;
      isInteracting = false;
      pauseTemporarily();
    }, { passive: true });

    viewport.addEventListener('wheel', () => pauseTemporarily(), { passive: true });
    viewport.addEventListener('scroll', normalizePosition, { passive: true });

    const animate = (now) => {
      const elapsed = Math.min(now - lastFrame, 40);
      lastFrame = now;

      if (mobileViewport.matches && !reducedMotion.matches && !isInteracting && now >= resumeAt) {
        const loopWidth = getLoopWidth();
        const duration = Number.parseFloat(track.dataset.sfClubsDuration) || 28;
        if (loopWidth > 0) {
          viewport.scrollLeft += (loopWidth / duration) * (elapsed / 1000);
          normalizePosition();
        }
      }

      window.requestAnimationFrame(animate);
    };

    window.requestAnimationFrame(animate);
  });
};

ready(() => setupMobileClubCarousels());
document.addEventListener('shopify:section:load', (event) => setupMobileClubCarousels(event.target));

const sfValues = (cards, attribute) => Array.from(new Set(cards.flatMap((card) => (card.dataset[attribute] || '').split('|').map((value) => value.trim()).filter(Boolean))));

const applySuperfootCollectionFilters = () => {
  const params = new URLSearchParams(window.location.search);
  const selectedSurface = params.get('sf_surface') || '';
  const selectedSize = params.get('sf_size') || '';
  const selectedJerseySeason = params.get('sf_jersey_season') || '';
  const selectedJerseyKit = params.get('sf_jersey_kit') || '';
  const selectedJerseyVersion = params.get('sf_jersey_version') || '';

  document.querySelectorAll('.product-grid__item[data-sf-available-sizes]').forEach((card) => {
    const hasSurface = !selectedSurface || (card.dataset.sfSurfaces || '').split('|').includes(selectedSurface);
    const hasSize = !selectedSize || (card.dataset.sfAvailableSizes || '').split('|').includes(selectedSize);
    const hasJerseySeason = !selectedJerseySeason || (card.dataset.sfJerseySeasons || '').split('|').includes(selectedJerseySeason);
    const hasJerseyKit = !selectedJerseyKit || (card.dataset.sfJerseyKits || '').split('|').includes(selectedJerseyKit);
    const hasJerseyVersion = !selectedJerseyVersion || (card.dataset.sfJerseyVersions || '').split('|').includes(selectedJerseyVersion);
    const visible = hasSurface && hasSize && hasJerseySeason && hasJerseyKit && hasJerseyVersion;
    card.hidden = !visible;
    card.classList.toggle('sf-size-filter-hidden', !visible);
  });
};

const updateSuperfootCollectionFilter = (key, value) => {
  const url = new URL(window.location.href);
  if (value) url.searchParams.set(key, value);
  else url.searchParams.delete(key);
  url.searchParams.delete('page');
  window.history.pushState({}, '', url.toString());
  document.querySelectorAll('[data-sf-collection-filter]').forEach((filter) => filter.remove());
  setupSuperfootCollectionFilters();
  setupSuperfootJerseyFilters();
};

const createSuperfootFilter = (type, values, activeValue) => {
  const isSize = type === 'size';
  const label = isSize ? 'Available size' : 'Surface';
  const hint = isSize ? 'Only shows boots available in the selected size.' : 'Choose a surface available in this collection.';
  const key = isSize ? 'sf_size' : 'sf_surface';
  const className = isSize ? 'sf-size-filter' : 'sf-surface-filter-live';
  const wrapper = document.createElement('details');
  wrapper.className = `${className} facets__panel`;
  wrapper.dataset.sfCollectionFilter = type;
  wrapper.open = true;
  wrapper.innerHTML = `
    <summary class="facets__summary"><span>${label}</span><span class="svg-wrapper">⌄</span></summary>
    <div class="facets__panel-content sf-collection-filter__panel">
      <div class="sf-collection-filter__grid">
        ${values.map((value) => `<label class="sf-collection-filter__chip${value === activeValue ? ' is-active' : ''}"><input type="radio" name="${key}" value="${value}"${value === activeValue ? ' checked' : ''}><span>${value}</span></label>`).join('')}
      </div>
      <button class="sf-collection-filter__clear" type="button">${isSize ? 'All sizes' : 'All surfaces'}</button>
      <p class="sf-collection-filter__note">${hint}</p>
    </div>
  `;
  wrapper.addEventListener('change', (event) => {
    const input = event.target.closest(`input[name="${key}"]`);
    if (input) updateSuperfootCollectionFilter(key, input.value);
  });
  wrapper.querySelector('.sf-collection-filter__clear')?.addEventListener('click', () => updateSuperfootCollectionFilter(key, ''));
  return wrapper;
};

const setupSuperfootCollectionFilters = (root = document) => {
  injectSuperfootCollectionFilterStyles();
  const grid = root.querySelector('.product-grid-container') || document.querySelector('.product-grid-container');
  if (!grid) return;
  const form = document.querySelector('theme-drawer#filters-drawer form[id*="overflow"]');
  if (!form) return;

  const cards = Array.from(document.querySelectorAll('.product-grid__item[data-sf-available-sizes]'));
  const surfaces = sfValues(cards, 'sfSurfaces').filter((surface) => ['FG', 'AG', 'TF'].includes(surface));
  const sizes = sfValues(cards, 'sfAvailableSizes').sort((a, b) => Number(a) - Number(b));
  const params = new URLSearchParams(window.location.search);
  const target = form.querySelector('.facets__filters-wrapper') || form.querySelector('scroll-hint') || form;

  form.closest('theme-drawer')?.querySelectorAll('.sf-surface-filter').forEach((filter) => { filter.hidden = true; });
  if (surfaces.length && !form.querySelector('[data-sf-collection-filter="surface"]')) target.prepend(createSuperfootFilter('surface', surfaces, params.get('sf_surface') || ''));
  if (sizes.length && !form.querySelector('[data-sf-collection-filter="size"]')) target.prepend(createSuperfootFilter('size', sizes, params.get('sf_size') || ''));
  applySuperfootCollectionFilters();
};

const injectSuperfootCollectionFilterStyles = () => {
  if (document.getElementById('sf-size-filter-styles')) return;
  const style = document.createElement('style');
  style.id = 'sf-size-filter-styles';
  style.textContent = `
    .sf-size-filter,.sf-surface-filter-live{margin:0;border-bottom:1px solid rgba(23,23,23,.12)}
    .sf-size-filter .facets__summary,.sf-surface-filter-live .facets__summary{min-height:56px;padding:0 var(--theme-drawer-padding,20px);color:#171717;font-size:.82rem;font-weight:900;letter-spacing:.06em;text-transform:uppercase}
    .sf-collection-filter__panel{padding:0 var(--theme-drawer-padding,20px) 18px}
    .sf-collection-filter__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}
    .sf-collection-filter__chip{position:relative;min-height:42px;display:grid;place-items:center;border:1px solid rgba(23,23,23,.16);border-radius:8px;background:#fff;color:#171717;font-size:.86rem;font-weight:900;cursor:pointer;transition:background-color .18s ease,border-color .18s ease,color .18s ease,transform .18s ease}
    .sf-collection-filter__chip:hover{transform:translateY(-1px);border-color:rgba(227,38,54,.42)}
    .sf-collection-filter__chip input{position:absolute;opacity:0;pointer-events:none}
    .sf-collection-filter__chip.is-active,.sf-collection-filter__chip:has(input:checked){border-color:#171717;background:#171717;color:#fff}
    .sf-collection-filter__clear{width:100%;min-height:38px;margin-top:10px;border:1px solid rgba(23,23,23,.14);border-radius:8px;background:transparent;color:#b91f2c;font-size:.72rem;font-weight:900;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}
    .sf-collection-filter__note{margin:9px 0 0;color:#6b6f76;font-size:.72rem;line-height:1.35}
    .sf-size-filter-hidden{display:none!important}
    @media (max-width:749px){.sf-collection-filter__grid{grid-template-columns:repeat(3,minmax(0,1fr))}.sf-collection-filter__chip{min-height:40px;border-radius:7px}}
  `;
  document.head.append(style);
};

ready(() => setupSuperfootCollectionFilters());
document.addEventListener('shopify:section:load', (event) => setupSuperfootCollectionFilters(event.target));
document.addEventListener('shopify:section:unload', applySuperfootCollectionFilters);
document.addEventListener('click', (event) => {
  if (!event.target.closest('[on\\:click*="filters-drawer"]')) return;
  window.setTimeout(() => {
    setupSuperfootCollectionFilters();
    setupSuperfootJerseyFilters();
  }, 60);
});

const jerseyFilterLabels = {
  season: 'Season',
  kit: 'Kit type',
  version: 'Version',
};

const setupSuperfootJerseyFilters = (root = document) => {
  const grid = root.querySelector('.product-grid-container') || document.querySelector('.product-grid-container');
  const form = document.querySelector('theme-drawer#filters-drawer form[id*="overflow"]');
  if (!grid || !form) return;

  const cards = Array.from(document.querySelectorAll('.product-grid__item[data-sf-jersey="true"]'));
  if (!cards.length) return;
  const params = new URLSearchParams(window.location.search);
  const filters = [
    { type: 'season', key: 'sf_jersey_season', attribute: 'sfJerseySeasons', order: ['26/27', '25/26', 'RETRO'] },
    { type: 'kit', key: 'sf_jersey_kit', attribute: 'sfJerseyKits', order: ['HOME', 'AWAY', 'THIRD', 'FOURTH', 'SPECIAL EDITION'] },
    { type: 'version', key: 'sf_jersey_version', attribute: 'sfJerseyVersions', order: ['PLAYER VERSION', 'FAN VERSION'] },
  ];
  const target = form.querySelector('.facets__filters-wrapper') || form.querySelector('scroll-hint') || form;

  filters.forEach(({ type, key, attribute, order }) => {
    if (form.querySelector(`[data-sf-collection-filter="jersey-${type}"]`)) return;
    const values = sfValues(cards, attribute).sort((a, b) => order.indexOf(a) - order.indexOf(b));
    if (!values.length) return;
    const wrapper = document.createElement('details');
    wrapper.className = 'sf-size-filter facets__panel';
    wrapper.dataset.sfCollectionFilter = `jersey-${type}`;
    wrapper.open = true;
    wrapper.innerHTML = `
      <summary class="facets__summary"><span>${jerseyFilterLabels[type]}</span><span class="svg-wrapper">⌄</span></summary>
      <div class="facets__panel-content sf-collection-filter__panel">
        <div class="sf-collection-filter__grid">
          ${values.map((value) => `<label class="sf-collection-filter__chip${params.get(key) === value ? ' is-active' : ''}"><input type="radio" name="${key}" value="${value}"${params.get(key) === value ? ' checked' : ''}><span>${value === 'RETRO' ? 'Retro' : value.replace(/\\b\\w/g, (letter) => letter.toUpperCase()).replace('26/27', '26/27').replace('25/26', '25/26')}</span></label>`).join('')}
        </div>
        <button class="sf-collection-filter__clear" type="button">All ${jerseyFilterLabels[type].toLowerCase()}s</button>
      </div>
    `;
    wrapper.addEventListener('change', (event) => {
      const input = event.target.closest(`input[name="${key}"]`);
      if (input) updateSuperfootCollectionFilter(key, input.value);
    });
    wrapper.querySelector('.sf-collection-filter__clear')?.addEventListener('click', () => updateSuperfootCollectionFilter(key, ''));
    target.prepend(wrapper);
  });
  applySuperfootCollectionFilters();
};

ready(() => setupSuperfootJerseyFilters());
document.addEventListener('shopify:section:load', (event) => setupSuperfootJerseyFilters(event.target));
